import { render, staticRenderFns } from "./AppStage.vue?vue&type=template&id=5aac6ae8&scoped=true&"
import script from "./AppStage.vue?vue&type=script&lang=js&"
export * from "./AppStage.vue?vue&type=script&lang=js&"
import style0 from "./AppStage.vue?vue&type=style&index=0&id=5aac6ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac6ae8",
  null
  
)

export default component.exports